<template>
    <v-container fill-height fluid style="background-color: black">
        <v-row align-center justify-center>
            <v-col cols="12" sm="12">
                <v-spacer/>
                <v-img contain height="200" class="mt-5" :src="require('../assets/logo.png')"/>
                <v-spacer/>
            </v-col>
            <v-col cols="12" sm="12">
                <v-card class="elevation-12" style="margin-left: 30%; margin-right: 30%;">
                    <v-toolbar dark color="secondary">
                        <v-toolbar-title>Please Login</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-form>
                            <v-text-field v-model="username" name="login"
                                          placeholder="Username" type="text"/>
                            <v-text-field v-model="password" name="password"
                                          placeholder="Password" id="password" type="password"/>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn :loading="isLoading" :disabled="isLoading" @click="doLogin" color="primary">Login
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {AuthHttp} from "../http/auth";
    import {mapMutations} from "vuex";

    export default {
        name: "Login",
        data() {
            return {
                username: '',
                password: '',
                isLoading: false
            }
        },
        methods: {
            ...mapMutations("app", ["setToast", "setLoggedIn", "setToken"]),
            async doLogin() {
                if (this.username.length > 0 && this.password.length > 0) {
                    this.isLoading = true;
                    try {
                        const token = await AuthHttp.login(this.username, this.password);
                        await this.setLoggedIn(true);
                        await this.setToken(token.token);
                        this.setToast({color: 'success', text: 'Sign in successful', show: true});
                        await this.$router.replace('/');
                    } catch (e) {
                        if (e.response) {
                            this.setToast({color: 'error', text: e.response.data, show: true})
                        } else {
                            this.setToast({color: 'error', text: e.message, show: true})
                        }
                    } finally {
                        this.isLoading = false;
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>
